<template>
  <div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Поиск: </span>
      </div>
      <input type="text" class="form-control" v-model="search"/>
    </div>

    <table class="table">
      <thead>
      <tr>
        <th>ФИО</th>
      </tr>
      </thead>

      <tbody>
      <tr
        v-for="(client, clientKey) in data"
        :key="clientKey">
        <td>
          <div
            @click="$emit('select-client', client.id)"
            class="cursor-pointer">
            <img :src="client.image"
                 width="40"
                 class="img-thumbnail rounded-circle mr-3"
                 alt="...">

            {{ client.fullname }}
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ClientList',

  props: ['clients'],

  data() {
    return {
      search: '',
    };
  },

  computed: {
    data() {
      const clients = this.clients.filter(client => {
        if (this.search === '') {
          return true;
        }

        return client.fullname.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
      });

      clients.sort((a, b) => {
        return a.fullname > b.fullname ? 1 : (a.fullname < b.fullname ? -1 : 0);
      });

      return clients;
    }
  },
};
</script>
